export default "__VITE_ASSET__C4HZBq_8__"